<template>
  <div
    class="data-board-s"
    :style="{
      border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9',
    }"
  >
    <div class="title">
      <div>
        <eui-icon icon="eicon-message" color="#333" font-size="18px" />
        <span class="text">留言板</span>
      </div>
    </div>
    <!-- { id: 1, name: '未回复' },
          { id: 2, name: '已回复' }, -->
    <div class="tabs-container">
      <el-tabs v-model="quickNavActive" class="tabs-area">
        <el-tab-pane label="全部留言" name="0"> </el-tab-pane>
        <el-tab-pane label="已回复" name="2"> </el-tab-pane>
        <el-tab-pane label="未回复" name="1"> </el-tab-pane>
      </el-tabs>
      <div class="message-content">
        <div v-for="item of messages" :key="item.id" class="message-item">
          <div class="left">
            <div class="top-title">
              <span @click="openMessage(item)">{{ item.title }}</span>
              <span class="tag">{{ messageTypeObj[item.messageType] }}</span>
            </div>
            <div class="bottom-info">
              <span>{{ item.createTime }}</span>
              <span>{{ item.senderCompanyName }}</span>
              <span>{{ item.contacts }}</span>
            </div>
          </div>
          <div class="right">
            <eui-btn
              v-if="item.status === 2"
              style="font-size: 12px"
              type="link"
              @click="openMessage(item)"
              >查看</eui-btn
            >
            <eui-btn
              v-if="item.status === 1"
              style="font-size: 12px"
              type="link"
              @click="openMessage(item)"
              >回复</eui-btn
            >
            <el-popconfirm
              confirm-button-text="确认"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确定删除此条留言吗？"
              @confirm="handleDelete(item.id)"
            >
              <template #reference>
                <eui-btn type="link" style="font-size: 12px; margin-left: 6px"
                  >删除</eui-btn
                >
              </template>
            </el-popconfirm>
          </div>
        </div>
        <div v-if="messages.length === 0" class="empty">暂无留言</div>
      </div>

      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, pager"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <messageBoardDialog
      :visible="visible"
      :set-visible="setVisible"
      :current="current"
      :refresh="getListHandle"
    />
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/home/index'; // queryPageForCompany
import MessageBoardDialog from './messageBoard/index.vue';

export default {
  components: { MessageBoardDialog },
  props: {
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listQuery: {
        pageNum: 1,
        pageSize: 4,
        status: '',
      },
      visible: false,
      current: {},
      total: 20,
      messages: [],
      quickNavActive: '0',
      messageTypeObj: {
        1: '商品',
        2: '订单',
        3: '询价',
        4: '物流',
        5: '支付',
        6: '招标',
        7: '其他',
      },
    };
  },
  watch: {
    quickNavActive(newVal) {
      if (newVal === '0') {
        this.listQuery.status = '';
      } else {
        this.listQuery.status = newVal;
      }
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
  },
  mounted() {
    this.getList(this.listQuery);
  },
  methods: {
    getListHandle() {
      this.getList(this.listQuery);
    },
    openMessage(row) {
      this.current = row;
      this.setVisible(true);
    },
    async getList(params) {
      const result = await Api.queryPageForCompany(params);
      if (result.code === '200') {
        this.messages = [...result.data.records];
      }
      this.total = result.data?.total || 0;
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleDelete(id) {
      Api.deleteMessage({ id }).then((res) => {
        if (res.code === '200') {
          this.$message.success({ message: '删除成功', duration: 1500 });
          this.getList(this.listQuery);
        }
      });
    },
    setVisible(bool) {
      this.visible = bool;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.title {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  height: 44px;
  padding: 0 20px;
  color: #333;
  .text {
    margin-left: 10px;
  }
  .more {
    color: #333;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: normal;
    &:hover {
      color: #0064c8;
    }
  }
}
.data-board-s {
  width: 100%;
  margin-top: 20px;
  .tabs-container {
    padding: 20px 20px 10px 20px;
    background: #fff;
  }
  ::v-deep .el-tabs--card {
    & > .el-tabs__header {
      margin-bottom: 5px;
      .el-tabs__nav {
        border: none;
      }
      .el-tabs__item {
        border: 1px solid #d9d9d9;
        border-left: 0;
        &:first-child {
          border-left: 1px solid #d9d9d9;
        }
      }
      .el-tabs__item.is-active {
        background: #f4f7ff;
        position: relative;
        color: #0064c8;
        &:first-child {
          border-left: 0;
          border-bottom: 0;
        }
        &:last-child {
          border-right: 0;
          border-bottom: 0;
        }
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: -1px;
          left: 0;
          right: 0;
          border-top: 2px solid #0064c8;
        }
      }
    }
  }
  .message-content {
    .empty {
      height: 70px;
      color: #bbb;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .message-item {
    display: flex;
    padding: 10px;
    background: #f8f8f8;
    margin-top: 4px;
    .left {
      flex: 1;
      .top-title {
        display: flex;
        align-items: center;
        color: #333;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 1;
        margin-bottom: 10px;
        span:nth-of-type(1) {
          cursor: pointer;
        }
        .tag {
          color: #fff;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 1;
          padding: 2px 4px;
          transform: scale(0.83333);
          background: #2587ff;
          border-radius: 3px;
          margin-left: 10px;
        }
      }
      .bottom-info {
        color: #666;
        font-size: 12px;
        font-style: normal;
        font-weight: 350;
        line-height: 12px;
        span {
          margin-right: 20px;
        }
      }
    }
    .right {
      flex-shrink: 0;
      flex-grow: 0;
      width: 200px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    &:hover {
      background: #f4f7ff;
      .top-title {
        color: #2587ff;
      }
    }
  }
}
</style>
